module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('isotope', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded:on.progress",
      value: (_vm.layout),
      expression: "layout",
      arg: "on",
      modifiers: {
        "progress": true
      }
    }],
    ref: "cpt",
    attrs: {
      "list": _vm.list,
      "id": "root_isotope",
      "options": _vm.isotope_options
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "element-item"
    }, [_c('app-inmobiliaria-widget', {
      attrs: {
        "item": item
      }
    })], 1)
  })), _vm._v(" "), _c('infinite-loading', {
    ref: "InfiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite,
      "distance": 500,
      "spinner": "spiral"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76391ffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppInmobiliaria.vue
// module id = 82
// module chunks = 1